<template>
  <v-menu
    ref="menu"
    v-model="showDatePicker"
    :close-on-content-click="false"
    :return-value="date"
    transition="scale-transition"
    offset-y
    min-width="300px"
    class="calendar-v-text-field"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        style="font-size: 0.85rem; width: 65%"
        outlined
        append-icon="fas fa-calendar-day"
        :value="dateString"
        readonly
        v-on="on"
        v-bind="$attrs"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      type="month"
      no-title
      scrollable
      :min="min"
      :max="max"
      :events="eventMonths"
      event-color="green lighten-1"
    >
      <div class="d-flex flex-column">
        <!-- <v-btn text color="primary" @click="setLatest" v-if="latest"
          >LATEST</v-btn
        > -->
        <v-btn text color="primary" @click="setStart" v-if="base_start"
          >BASE START</v-btn
        >
        <v-btn text color="primary" @click="setEnd" v-if="base_end"
          >BASE END</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="showDatePicker = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DatePickerInput from "@/components/DatePickerInput.vue";
import { computed, inject, ref, watch } from "@vue/composition-api";
import { DateTime } from "luxon";

export default {
  name: "ASorPeriodInput",
  components: { DatePickerInput },
  props: {
    value: String,
    min: String,
    max: String,
    eventMonths: Array,
  },
  setup(props, { root, emit }) {
    const base_start = inject("ASOR_BASE_START");
    const base_end = inject("ASOR_BASE_END");

    const date = ref(null);

    watch(
      () => props.value,
      (newValue) => {
        if (newValue) {
          if (["BASE_START", "BASE_END"].indexOf(newValue) !== -1) {
            date.value = null;
          } else {
            date.value = DateTime.fromFormat(newValue, "yyyyMM").toFormat(
              "yyyy-MM"
            );
          }
        }
      },
      { immediate: true }
    );
    watch(
      () => date.value,
      (newValue) => {
        if (newValue) {
          emit(
            "input",
            DateTime.fromFormat(newValue, "yyyy-MM").toFormat("yyyyMM")
          );
        }
      }
    );

    const dateString = computed(() => {
      //   return props.value ? root.$parsePeriod(props.value) : "";

      if (["BASE_START", "BASE_END"].indexOf(props.value) !== -1) {
        return (
          {
            BASE_START: `START(${root.$parsePeriod(base_start.value)})`,
            BASE_END: `END(${root.$parsePeriod(base_end.value)})`,
          }[props.value] || ""
        );
      }

      return props.value ? root.$parsePeriod(props.value) : "";
    });

    const showDatePicker = ref(false);

    const setStart = function () {
      if (base_start) {
        emit("input", "BASE_START");
        showDatePicker.value = false;
      }
    };

    const setEnd = function () {
      if (base_end) {
        emit("input", "BASE_END");
        showDatePicker.value = false;
      }
    };

    return {
      date,
      dateString,
      showDatePicker,
      setStart,
      setEnd,
      base_end,
      base_start,
    };
  },
};
</script>
